import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {LanguageCountryConfig} from '../../../config/languages/language-country.config';
import {LanguageService} from '../../../services/language.service';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.css'],
  standalone: false
})
export class LanguageSelectorComponent implements OnInit, OnDestroy {
  readonly languages = this.languageService.languages;
  selectedLanguage: LanguageCountryConfig = this.languageService.currentLanguage;
  isOpen = false;
  private languageSubscription: Subscription;

  constructor(private languageService: LanguageService) {}

  ngOnInit(): void {
    this.languageService.initialize();
    this.languageSubscription = this.languageService.currentLanguage$.subscribe(language => {
      this.selectedLanguage = language;
    });
  }

  ngOnDestroy(): void {
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }
  }

  toggle(event: MouseEvent): void {
    event.stopPropagation();
    this.isOpen = !this.isOpen;
  }

  changeLanguage(code: string, event: MouseEvent): void {
    event.stopPropagation();
    this.languageService.use(code);
    this.isOpen = false;
  }

  @HostListener('document:click')
  close(): void {
    this.isOpen = false;
  }

  @HostListener('document:keydown.escape')
  closeWithEscape(): void {
    this.isOpen = false;
  }
}
